import axios from '@/plugins/axios';

export const respondToInvitation = async ({ guestId, token, action }) => {
  const { data } = await axios.put(`/invitations/${token}/respond`, {
    guestId,
    status: action,
  });

  return data?.data;
};

export const createInvitation = async ({
  userId,
  modelId,
  type,
  email,
  guestId,
}) => {
  const { data } = await axios.post(`/users/${userId}/invitations`, {
    invitationType: type,
    subjectId: modelId,
    email: email,
    guestId: guestId,
  });

  return data;
};

export const revokeInvitation = async (invitationId) => {
  const { data } = await axios.put(`/invitations/${invitationId}/revoke`);

  return data;
};
